import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import { makeStyles, Box, Grid, Typography, IconButton } from '@material-ui/core';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import { retrieveContentfulImage } from '../../common/image.js';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';

var useStyles = makeStyles(function (theme) {
  return {
    img: {
      width: theme.spacing(8),
      height: theme.spacing(8)
    },
    imgContainer: {
      marginRight: theme.spacing(3),
      display: "flex",
      alignItems: "center"
    },
    closeIconButton: {
      margin: theme.spacing(-1.5)
    },
    errorStyle: {
      background: theme.palette.error.light
    },
    warningStyle: {
      background: theme.palette.secondary["A200"]
    },
    infoStyle: {
      background: theme.palette.secondary["100"]
    },
    successStyle: {
      background: theme.palette.primary["100"]
    },
    subtitle: {
      "& a": {
        color: theme.palette.black,
        fontWeight: "500",
        cursor: "pointer",
        wordWrap: "break-word",
        whiteSpace: "pre-wrap",
        textDecoration: "underline"
      }
    }
  };
});
var NotificationBanner = function NotificationBanner(_ref) {
  var notificationType = _ref.notificationType,
    title = _ref.title,
    subtitle = _ref.subtitle,
    imageUrl = _ref.imageUrl,
    imageTitle = _ref.imageTitle,
    actionButton = _ref.actionButton,
    closeButton = _ref.closeButton,
    onCloseButtonClick = _ref.onCloseButtonClick,
    onSubtitleClick = _ref.onSubtitleClick;
  var classes = useStyles();
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen,
    isSmallScreen = _useBreakpoints.isSmallScreen,
    isLargeScreen = _useBreakpoints.isLargeScreen;
  return /*#__PURE__*/React__default.createElement(Box, {
    className: clsx(_defineProperty({}, classes.errorStyle, notificationType === "error"), _defineProperty({}, classes.warningStyle, notificationType === "warning"), _defineProperty({}, classes.infoStyle, notificationType === "info"), _defineProperty({}, classes.successStyle, notificationType === "success")),
    py: !isExtraSmallScreen() ? 3 : 2,
    px: isExtraSmallScreen() ? 2 : isSmallScreen() ? 4 : 6
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    justify: "space-between"
  }, /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    item: true,
    md: 9,
    sm: 7,
    xs: true
  }, !isExtraSmallScreen() && !isSmallScreen() && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, imageUrl && /*#__PURE__*/React__default.createElement(Grid, {
    item: true,
    className: classes.imgContainer
  }, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    alt: imageTitle || "",
    src: retrieveContentfulImage(imageUrl, {
      width: 120,
      height: 120
    }),
    className: classes.img
  }))), /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, title && /*#__PURE__*/React__default.createElement(Typography, {
    variant: !isExtraSmallScreen() && !isSmallScreen() ? "h4" : "h6"
  }, title), subtitle && /*#__PURE__*/React__default.createElement(Box, {
    mt: 1.5
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: !isExtraSmallScreen() && !isSmallScreen() ? "body1" : "body2",
    className: classes.subtitle,
    dangerouslySetInnerHTML: {
      __html: subtitle
    },
    onClick: onSubtitleClick
  })))), /*#__PURE__*/React__default.createElement(Grid, {
    container: true,
    justify: "flex-end",
    alignItems: !isExtraSmallScreen() ? "center" : "flex-start",
    spacing: isLargeScreen() ? 8 : 4,
    item: true,
    md: 3,
    sm: 5,
    xs: closeButton ? 2 : 1
  }, actionButton && !isExtraSmallScreen() && /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, actionButton), closeButton && /*#__PURE__*/React__default.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React__default.createElement(IconButton, {
    className: classes.closeIconButton,
    onClick: onCloseButtonClick
  }, /*#__PURE__*/React__default.createElement(CloseIcon, null))))), actionButton && isExtraSmallScreen() && /*#__PURE__*/React__default.createElement(Box, {
    mt: 2
  }, actionButton));
};
NotificationBanner.propTypes = {
  notificationType: PropTypes__default.oneOf(["success", "info", "warning", "error"]),
  title: PropTypes__default.string,
  subtitle: PropTypes__default.string,
  imageUrl: PropTypes__default.string,
  imageTitle: PropTypes__default.string,
  actionButton: PropTypes__default.element,
  onCloseButtonClick: PropTypes__default.func,
  closeButton: PropTypes__default.bool,
  onSubtitleClick: PropTypes__default.func
};

export { NotificationBanner as default };
//# sourceMappingURL=NotificationBanner.js.map
